/**
 * Paragraph block eyebrow style functionality
 *
 * Wraps paragraph content with span element when using the eyebrow style variant.
 * This wrapper enables specific styling for eyebrow-styled paragraphs.
 *
 * @since 1.0.0
 */
function initEyebrowParagraphs() {
	const eyebrows = document.querySelectorAll('.is-style-eyebrow');

	eyebrows.forEach(eyebrow => {
		if (!eyebrow.querySelector('span')) {
			const content = eyebrow.innerHTML;
			eyebrow.innerHTML = `<span>${content}</span>`;
		}
	});
}

document.addEventListener('DOMContentLoaded', initEyebrowParagraphs);
